import { useMutation } from "react-query";
import { api } from "../api";
export const useSignIn = () => {
  const signIn = useMutation(() => api.signIn());
  return {
    ...signIn,
    mutate: signIn.mutate,
  };
};
